const APPNAME = '';
export const STAGE = `http://localhost:4000/api`;
export const PROD = `https://api.tariqat.org/api`;

export const ENV = `${PROD}`;
export const ADMIN = `${ENV}`;
export const LOGIN_API_ROOT = `${PROD}`;

export const ADMIN_LOGIN_API = `/admin/sign-in/`;
export const LIVE_BROADCAST_API = `/live-broadcast/`;
export const LIVE_BROADCAST_CATEGORY_API = `/playlist-category/`;
export const LIVE_BROADCAST_SUB_CATEGORY_API = `/playlist-sub-category/`;
export const SALAQEEN_API = `/saliqeen/`;
export const EVENT_API = `/event/`;
export const EVENTS_API = `/events/`;
export const LIVE_AUDIO_API = `/live-audio/`;
export const RECENT_EVENTS_API = `/recent-events/`;
export const UPCOMING_EVENTS_API = `/upcoming-events/`;
export const LIBRARY_API = `/book/`;
export const FAQ_API = `/faq/`;
export const FAQ_CATEGORIES_API = `/faq-categories/`;
export const FAQ_CATEGORY_API = `/faq-category/`;
export const REPLY_API = `/reply/`;
export const ITIKAAF_REGISTRATION_API = `/atikaaf/`;
export const ITIKAAF_SEND_OTP_API = `/itikaaf/send-otp`;
export const ITIKAAF_VERIFY_OTP_API = `/itikaaf/verify-otp`;
export const ITIKAAF_EVENTS_API = `/itikaaf/events`;
export const ITIKAAF_EVENT_REGISTER_API = `/itikaaf/events`;
export const ITIKAAF_CONFIRM_REGISTRATION_API = `/itikaaf/confirm-registration`;
export const ITIKAAF_REJECT_REGISTRATION_API = `/itikaaf/reject-registration`;
export const ITIKAAF_CONFIRM_REGISTRATION_AS_NAFIL_API = `/itikaaf/confirm-registration-as-nafil`;
export const FILE_UPLOAD_API = `/upload-single/`;
export const FILE_DOWNLOAD_API = `/download/`;
export const CONTACT_US_API = `/contact-us/`;
export const PROGRAM_REGISTRATION_FORM_API = `/program-registration/`;

export const LOGIN_API = `/management/login/`;
export const SIGNUP = `/management/signup/`;

export const ADMIN_API = '/admin/';
export const CREATE_SUB_ADMIN = '/admin/create-sub-admin';
export const UPDATE_SUB_ADMIN = '/admin/update-sub-admin';
export const TOGGLE_SUBADMIN_STATUS = '/admin/toggle-subadmin-status';
export const SUB_ADMIN_LIST = '/admin/sub-admin-list';
export const USER_LOGS = '/admin/logs';

// Masjid APIs
export const MASJID_API = `/masjid`;
export const MASJID_LIST_API = `/masjid`;
export const MASJID_CREATE_API = `/masjid`;
export const MASJID_UPDATE_API = `/masjid`; // Append /:id
export const MASJID_DELETE_API = `/masjid`; // Append /:id
export const MASJID_GET_BY_ID_API = `/masjid`; // Append /:id
export const MASJID_FLOOR_PLAN_TEMPLATE_API = `/masjid`; // Append /:masjidId/floor-plan-template

// Legacy Floor Plan APIs (for backward compatibility)
export const FLOORPLANAPI = `/masjid`;
export const CREATEFLOORPLANAPI = `/masjid`;

// Itikaaf Event APIs
export const EVENT_LIST_API = `/events`;
export const EVENT_CREATE_API = `/events`;
export const EVENT_GET_BY_ID_API = `/events`; // Append /:eventId
export const EVENT_UPDATE_API = `/events`; // Append /:eventId
export const EVENT_ARCHIVE_API = `/events`; // Append /:eventId/archive
export const EVENT_DELETE_API = `/events`; // Append /:eventId
export const EVENT_TEST_NOTIFICATION_API = `/events/test-registration-notification`;
export const EVENT_INSPECT_CONFIRMATION_LETTER_TEMPLATE_API = `/events/confirmation-letter-template/inspect`;
export const EVENT_TEST_CONFIRMATION_LETTER_NOTIFICATION_API = `/events/test-confirmation-letter-notification`;

// Event Registration Management APIs
export const EVENT_REGISTRATIONS_API = `/events`; // Append /:eventId/registrations
export const EVENT_REGISTRATIONS_STATS_API = `/events`; // Append /:eventId/registrations/stats
export const EVENT_SCAN_QR_API = `/events`; // Append /:eventId/scan-qr
export const REGISTRATION_GET_BY_ID_API = `/registrations`; // Append /:registrationId
export const REGISTRATION_ACCEPT_API = `/registrations`; // Append /:registrationId/accept
export const REGISTRATION_REJECT_API = `/registrations`; // Append /:registrationId/reject
export const REGISTRATION_BULK_ACCEPT_API = `/registrations/bulk-accept`;
export const REGISTRATION_BULK_REJECT_API = `/registrations/bulk-reject`;
export const REGISTRATION_BULK_SEND_CONFIRMATION_API = `/registrations/bulk-send-confirmation`;
export const REGISTRATION_BULK_RESEND_NOTIFICATION_API = `/registrations/bulk-resend-notification`;
export const REGISTRATION_UPDATE_ITIKAAF_TYPE_API = `/registrations`; // Append /:registrationId/update-itikaaf-type
export const REGISTRATION_SEND_CONFIRMATION_API = `/registrations`; // Append /:registrationId/send-confirmation
export const REGISTRATION_ASSIGN_SEAT_API = `/registrations`; // Append /:registrationId/assign-seat
export const REGISTRATION_BULK_ASSIGN_SEATS_API = `/registrations/bulk-assign-seats`;
export const REGISTRATION_UNASSIGN_SEAT_API = `/registrations`; // Append /:registrationId/unassign-seat
export const REGISTRATION_SWAP_SEATS_API = `/registrations/swap-seats`;
export const REGISTRATION_DELETE_API = `/registrations`; // Append /:registrationId
export const EVENT_SEAT_MAP_API = `/events`; // Append /:eventId/seat-map

// Print Batch Management APIs
export const PRINT_BATCH_CREATE_API = `/events`; // Append /:eventId/print-export
export const PRINT_BATCH_STATUS_API = `/events/print-batches`; // Append /:batchId/status
export const PRINT_BATCH_LIST_API = `/events`; // Append /:eventId/print-batches

// Visitor Registration APIs
export const VISITOR_REGISTRATION_API = `/visitors/register`;
export const VISITORS_API = `/visitors`;
export const VISITOR_ACCEPT_API = `/visitors`;
export const VISITOR_REJECT_API = `/visitors`;
export const VISITOR_SCAN_API = `/visitors/scan`;
export const VISITOR_STATS_API = `/visitors/stats`;

// User Registration APIs
export const USER_REGISTER_API = `/users/register`;
export const USERS_LIST_API = `/users`;
